// remove unnecessary slashes except protocol
export const getFixedUrl = (url: string): string => {
  const urlO = new URL(url)
  return urlO.origin + '/' + urlO.pathname.split('/').filter(Boolean).join('/')
}
